import { useFormContext } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import { cn } from "@/lib/utils";

interface CustomFieldSectionProps {
    fieldKey: "custom_1" | "custom_2" | "custom_3";
}

export default function CustomFieldSection({ fieldKey }: CustomFieldSectionProps) {
    const { register } = useFormContext();

    return (
        <div className="space-y-2 bg-card">
            <Textarea
                {...register(`custom_fields.${fieldKey}`)}
                placeholder="Add details..."
                rows={1}
                className={cn(
                    "text-xs bg-transparent ",
                    "placeholder:text-muted-foreground/40 placeholder:font-normal",
                    "resize-none min-h-[40px] px-3",
                )}
                maxLength={1000}
            />
        </div>
    );
}
